import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import * as ActorAudiobookListActions from 'rebook/apps/catalog/actions/ActorAudiobookListActions';
import pluralize from 'rebook/apps/utils/text/pluralize';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';

import styles from './style.scss';


class ActorAudiobookListView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    const { actorSlug: slug } = match.params;
    return store.dispatch(ActorAudiobookListActions.fetchInitialData(match, null, { slug }));
  }

  constructor(props) {
    super(props);
    const actor = get(props, 'location.state.actor', null);
    this.state = {
      actor,
    };
  }

  componentDidMount() {
    const { match, location, actorAudiobookList } = this.props;
    const { actor } = this.state;
    this.props.ActorAudiobookListActions.fetchInitialData(match, location, actor);
    if (!actorAudiobookList.audiobookList) {
    }
  }

  componentDidUpdate(prevState) {
    const { match, location, actorAudiobookList } = this.props;
    const { actor: prevActor } = prevState.actorAudiobookList;
    const { actor, audiobookList } = actorAudiobookList;
    if (get(actor, 'id', null) !== get(prevActor, 'id', null) && !audiobookList) {
      this.props.ActorAudiobookListActions.fetchInitialData(match, location);
    }
  }

  componentWillUnmount() {
    this.props.ActorAudiobookListActions.resetData();
  }

  changePage(pageNumber) {
    this.props.ActorAudiobookListActions.fetchAudiobookList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    this.props.ActorAudiobookListActions.fetchAudiobookList({ orderBy, pageNumber: 1 });
  }

  resetFilters() {
    this.props.ActorAudiobookListActions.fetchAudiobookList({ orderBy: 'popular' });
  }

  render() {
    const { actor, audiobookList, totalBookCount, pageNumber, lastPageNumber, orderBy } = this.props.actorAudiobookList;

    return (
      <div>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Все аудиокниги', url: '/catalog/books/?t=audio' },
            { text: get(actor, 'cover_name', ''), url: '' },
          ]} />
          <div className="sectionHeader">
            {actor && actor.cover_name
              ? (
                <h1>Все аудиокниги чтеца &laquo;{actor.cover_name}&raquo;</h1>
              )
              : (
                <h1>Все аудиокниги чтеца</h1>
              )
            }
          </div>
          <div className={styles.count}>
            {totalBookCount}&nbsp;{`${pluralize(totalBookCount, 'аудиокнига', 'аудиокниги', 'аудиокниг')}`}
          </div>
          {audiobookList &&
            <div className={styles.filters}>
              <CatalogFilter
                orderBy={orderBy}
                isSubscriptionEnabled={false}
                isBookTypeEnabled={false}
                isResultEmpty={audiobookList && audiobookList.length === 0}
                onChangeOrder={(value) => this.changeOrderBy(value)}
                onResetFilter={()=>this.resetFilters()} />
            </div>
          }
          {(audiobookList && audiobookList.length > 0) && (
            <BookList books={audiobookList} />
          )}
          {(audiobookList === null) && (
            <BookList books={[...Array(5)]} />
          )}
          {(audiobookList && audiobookList.length === 0) && (
            <EmptyFilterResult />
          )}
          {(lastPageNumber > 1 && audiobookList && audiobookList.length > 0) && (
            <ContextPagination
              extraClassName="jest-actor-audiobook-list-pagination"
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    actorAudiobookList: state.actorAudiobookList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ActorAudiobookListActions: bindActionCreators(ActorAudiobookListActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActorAudiobookListView);
